import { render, staticRenderFns } from "./ConfigForm.vue?vue&type=template&id=3b867402&scoped=true"
import script from "./ConfigForm.vue?vue&type=script&lang=ts"
export * from "./ConfigForm.vue?vue&type=script&lang=ts"
import style0 from "./ConfigForm.vue?vue&type=style&index=0&id=3b867402&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b867402",
  null
  
)

export default component.exports